import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class Smileys {
  init() {
    this.leftSmileys();
    this.rightSmileys();
  }

  leftSmileys() {
    const leftSmileys = document.querySelectorAll('.smiley-wrapper .smiley--left');

    leftSmileys.length && leftSmileys.forEach(smiley => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: smiley,
          start: 'top bottom',
          scrub: 1,
        },
        ease: "elastic",
      });

      const face = smiley.querySelector('.smiley__face');
      const bigBubble = smiley.querySelector('.smiley__bubble-big');
      const smallBubble = smiley.querySelector('.smiley__bubble-small');

      gsap.to(face, {
        x: "random(0, 10)",
        y: "random(0, 10)",
        duration: 3,
        repeat: -1,
        repeatRefresh: true,
        ease: "none"
      })

      gsap.to(bigBubble, {
        x: "random(0,-10)",
        y: "random(0,-10)",
        duration: 3,
        repeat: -1,
        yoyo: true,
        ease: "none"
      })

      gsap.to(smallBubble, {
        x: "random(0,-10)",
        y: "random(0,10)",
        duration: 3,
        repeat: -1,
        yoyo: true,
        ease: "none"
      })


      tl
        .from(face, {
          scale: 0.8,
          transformOrigin: 'center',
        })
        .from(bigBubble, {
        }, 0.1)
        .from(smallBubble, {
        }, 0.2)
    })
  }

  rightSmileys() {
    const rightSmileys = document.querySelectorAll('.smiley-wrapper .smiley--right');

    rightSmileys.length && rightSmileys.forEach(smiley => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: smiley,
          start: 'top bottom',
          scrub: 1,
        },
        ease: "none",
      });

      const face = smiley.querySelector('.smiley__face');
      const bigBubble = smiley.querySelector('.smiley__bubble-big');
      const smallBubble = smiley.querySelector('.smiley__bubble-small');

      gsap.to(face, {
        x: "random(0, -10)",
        y: "random(0, -10)",
        duration: 3,
        repeat: -1,
        repeatRefresh: true,
        ease: "none"
      })

      gsap.to(bigBubble, {
        x: "random(0, 0, 2)",
        y: "random(, 20, 3)",
        duration: 3,
        repeat: -1,
        repeatRefresh: true,
        ease: "none"
      })

      gsap.to(smallBubble, {
        x: "random(0, 20, 3)",
        y: "random(0, -20, 3)",
        duration: 3,
        repeat: -1,
        repeatRefresh: true,
        ease: "none"
      })


      tl
        .from(face, {
          scale: 0.5,
          transformOrigin: 'center',
        })
        .from(bigBubble, {
        }, 0.1)
        .from(smallBubble, {
        }, 0.2)
    })
  }

}